import { weights } from '../context/CerebroThemeProvider';
import { Button, ButtonProps, styled } from '@mui/material';

export const CerebroTextButton = styled(Button, {
	shouldForwardProp: prop => prop !== 'wide',
})(({ color, variant, size, theme }) => {
	let fontSize = 16;
	let lineHeight = '18px';

	if (size === 'small') {
		fontSize = 14;
		lineHeight = '16px';
	} else if (size === 'large') {
		fontSize = 18;
		lineHeight = '20px';
	}

	const paletteColor = color === 'error' ? theme.palette.error : theme.palette.primary;

	return {
		color: theme.palette.gray.dark,
		fontWeight: weights.semibold,
		fontSize,
		lineHeight,
		textTransform: 'none',

		border: variant === 'outlined' ? `2px solid ${paletteColor.main}` : '2px solid transparent',
		padding: theme.spacing(0.75, 2),

		'&:hover': {
			backgroundColor: paletteColor.light,
			backgroundOpacity: theme.palette.action.hoverOpacity,
			border: variant === 'outlined' ? `2px solid ${paletteColor.main}` : '2px solid transparent',
			color: color === 'error' ? theme.palette.error.contrastText : theme.palette.gray.dark,

			'& svg': {
				color: color === 'error' ? theme.palette.error.contrastText : theme.palette.gray.dark,
			},
		},
	};
}) as typeof Button;
